<template>
  <b-modal
    id="clientStoreModal"
    ref="clientStoreModal"
    scrollable
    @hide="close"
  >
    <template #modal-header>
      <h5>{{ $t("NEW") }} {{ $t("CUSTOMER") }}</h5>
      <b-button size="sm" @click="resetModal()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.028"
          height="17.028"
          viewBox="0 0 17.028 17.028"
        >
          <path
            id="Icon_material-close"
            data-name="Icon material-close"
            d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
            transform="translate(-7.5 -7.5)"
            fill="#393939"
          />
        </svg>
      </b-button>
    </template>

    <form @submit.prevent="addCLI">
      <div class="center">
        <div style="width: 100%">
          <b-form-group label="Type*">
            <b-form-select
              v-model="v$.newclient.type.$model"
              :options="optionsTypeClient"
              :state="validateState('type')"
              aria-describedby="type-feedback"
              @change="v$.$reset()"
            ></b-form-select>
            <error-handle
              :list="v$.newclient.type.$errors"
              id="type-feedback"
            ></error-handle>
            <div v-if="erreurlist.type" class="error-message">
              <ul v-if="Array.isArray(erreurlist.type)">
                <span v-for="(e, index) in erreurlist.type" :key="index">
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.type }}</span>
            </div>
          </b-form-group>
        </div>
        <div v-if="isProfessionel" style="width: 100%">
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Raison sociale') + '*'">
                <b-form-input
                  v-model="v$.newclient.raison_sociale.$model"
                  oninput="this.value = this.value.toUpperCase()"
                  :state="validateState('raison_sociale')"
                  aria-describedby="raison_sociale-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.raison_sociale.$errors"
                  id="raison_sociale-feedback"
                ></error-handle>
                <div v-if="erreurlist.raison_sociale" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.raison_sociale)">
                    <span
                      v-for="(e, index) in erreurlist.raison_sociale"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.raison_sociale }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Nom de commercial')">
                <b-form-input
                  v-model="newclient.nom_commercial"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <div v-if="erreurlist.nom_commercial" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.nom_commercial)">
                    <span
                      v-for="(e, index) in erreurlist.nom_commercial"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.nom_commercial }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('SIRET') + '*'">
                <b-form-input
                  v-model="v$.newclient.siret.$model"
                  :state="validateState('siret')"
                  aria-describedby="siret-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.siret.$errors"
                  id="siret-feedback"
                ></error-handle>
                <div v-if="erreurlist.siret" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.siret)">
                    <span
                      v-for="(e, index) in erreurlist.siret"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.siret }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <h5 class="titresociete mt-3">{{ $t("Signataire") }}</h5>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Civilite')">
                <b-form-select
                  v-model="newclient.civilite"
                  :options="optionsCivilite"
                ></b-form-select>
                <div v-if="erreurlist.civilite" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.civilite)">
                    <span
                      v-for="(e, index) in erreurlist.civilite"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.civilite }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('NAME') + '*'">
                <b-form-input
                  v-model="v$.newclient.nom.$model"
                  oninput="this.value = this.value.toUpperCase()"
                  :state="validateState('nom')"
                  aria-describedby="nom-pro-feedback"
                  @input="updateSignataireNom"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.nom.$errors"
                  id="nom-pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.signataire_nom" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.signataire_nom)">
                    <span
                      v-for="(e, index) in erreurlist.signataire_nom"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.signataire_nom }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('SURNAME') + '*'">
                <b-form-input
                  v-model="v$.newclient.prenom.$model"
                  oninput="this.value = this.value.toUpperCase()"
                  :state="validateState('prenom')"
                  aria-describedby="prenom-pro-feedback"
                  @input="updateSignatairePrenom"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.prenom.$errors"
                  id="prenom-pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.signataire_prenom" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.signataire_prenom)">
                    <span
                      v-for="(e, index) in erreurlist.signataire_prenom"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.signataire_prenom }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Fonction')">
                <b-form-input
                  v-model="newclient.fonction"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <div v-if="erreurlist.fonction" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.fonction)">
                    <span
                      v-for="(e, index) in erreurlist.fonction"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.fonction }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <h5 class="titresociete mt-3">{{ $t("ADDRESS") }}</h5>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('STREET') + '*'">
                <b-form-input
                  v-model="v$.newclient.rue.$model"
                  :state="validateState('rue')"
                  aria-describedby="rue-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.rue.$errors"
                  id="rue-feedback"
                ></error-handle>
                <div v-if="erreurlist.rue" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.rue)">
                    <span
                      v-for="(e, index) in erreurlist.rue"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.rue }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Complément d\'adresse')">
                <b-form-input
                  v-model="newclient.complement_adresse"
                ></b-form-input>
                <div v-if="erreurlist.complement_adresse" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.complement_adresse)">
                    <span
                      v-for="(e, index) in erreurlist.complement_adresse"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.complement_adresse }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('POSTAL_CODE') + '*'">
                <b-form-input
                  v-model="v$.newclient.cp.$model"
                  :state="validateState('cp')"
                  aria-describedby="cp-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.cp.$errors"
                  id="cp-feedback"
                ></error-handle>
                <div v-if="erreurlist.cp" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.cp)">
                    <span
                      v-for="(e, index) in erreurlist.cp"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.cp }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('CITY') + '*'">
                <b-form-input
                  v-model="v$.newclient.ville.$model"
                  :state="validateState('ville')"
                  aria-describedby="ville-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.ville.$errors"
                  id="ville-feedback"
                ></error-handle>
                <div v-if="erreurlist.ville" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.ville)">
                    <span
                      v-for="(e, index) in erreurlist.ville"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.ville }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('COUNTRY') + ''">
                <multiselect
                  v-model="newclient.pays"
                  :searchable="true"
                  :close-on-select="true"
                  :multiple="false"
                  :options="getAllcountries"
                  label="name"
                  track-by="id"
                >
                  <template slot="noResult">
                    {{ $t("NO_DATA_FOUND") }}
                  </template>
                </multiselect>
                <div v-if="erreurlist.pays" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.pays)">
                    <span
                      v-for="(e, index) in erreurlist.pays"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.pays }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <h5 class="titresociete mt-3">{{ $t("CONTACT") }}</h5>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('EMAIL') + '*'">
                <b-form-input
                  v-model="v$.newclient.email.$model"
                  type="email"
                  :state="validateState('email')"
                  aria-describedby="email-pro-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.email.$errors"
                  id="email-pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.email" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.email)">
                    <span
                      v-for="(e, index) in erreurlist.email"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.email }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Téléphone portable') + '**'">
                <template>
                  <phone :tel="newclient.tel_mobile_pro" @phoneNumber="formatMobileNumberPro($event)"></phone>
                </template>
                <error-handle
                  :list="v$.newclient.tel_mobile_pro.phone_number.$errors"
                  id="tel_mobile_pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.tel_mobile_pro" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.tel_mobile_pro)">
                    <span
                      v-for="(e, index) in erreurlist.tel_mobile_pro"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.tel_mobile_pro }}</span>
                </div>
                <div
                  v-if="
                    newclient.tel_mobile_pro && newclient.tel_mobile_pro.phone_number && resultValidMobilePro == false
                  "
                  class="error-message"
                >
                  {{ $t("ERROR_PHONE") }}
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Téléphone fixe') + '**'">
                <template>
                  <phone :tel="newclient.tel_fixe_pro" @phoneNumber="formatFixedNumberPro($event)"></phone>
                </template>
                <error-handle
                  :list="v$.newclient.tel_fixe_pro.phone_number.$errors"
                  id="tel_fixe_pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.tel_fixe_pro" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.tel_fixe_pro)">
                    <span
                      v-for="(e, index) in erreurlist.tel_fixe_pro"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.tel_fixe_pro }}</span>
                </div>
                <div
                  v-if="
                    newclient.tel_fixe_pro && newclient.tel_fixe_pro.phone_number && resultValidFixePro == false
                  "
                  class="error-message"
                >
                  {{ $t("ERROR_PHONE") }}
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('ZONE') + '*'">
                <b-form-select
                  v-model="v$.newclient.zone.$model"
                  :options="optionsZone"
                  text-field="text"
                  value-field="value"
                  :state="validateState('zone')"
                  aria-describedby="zone-pro-feedback"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- {{ $t("ZONE") }} --</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <error-handle
                  :list="v$.newclient.zone.$errors"
                  id="zone-pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.zone" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.zone)">
                    <span
                      v-for="(e, index) in erreurlist.zone"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.zone }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Role') + '*'">
                <b-form-select
                  v-model="v$.newclient.type_occupation.$model"
                  :options="optionsTypeOccupation"
                  text-field="text"
                  value-field="value"
                  :state="validateState('type_occupation')"
                  aria-describedby="type_occupation-pro-feedback"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- {{ $t("Role") }} --</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <error-handle
                  :list="v$.newclient.type_occupation.$errors"
                  id="type_occupation-pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.type_occupation" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.type_occupation)">
                    <span
                      v-for="(e, index) in erreurlist.type_occupation"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.type_occupation }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <h5 class="titresociete">{{ $t("COMPANY_BANK") }}</h5>
          <div class="row mt-2">
            <div class="col-md-6 col-lg-6 col-sm-12 py-0">
              <b-form-group :label="$t('ACCOUNT_OWNER')">
                <b-form-input
                  v-model="v$.newclient.titulaire_compte.$model"
                  :state="validateState('titulaire_compte')"
                  aria-describedby="titulaire_compte-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.titulaire_compte.$errors"
                  id="titulaire_compte-feedback"
                ></error-handle>
                <div
                  v-if="erreurlist.titulaire_compte"
                  class="error-message"
                >
                  <ul v-if="Array.isArray(erreurlist.titulaire_compte)">
                    <span
                      v-for="(e, index) in erreurlist.titulaire_compte"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.titulaire_compte }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 py-0">
              <b-form-group label="IBAN" label-for="IBAN">
                <b-form-input
                  v-model="v$.newclient.IBAN.$model"
                  :state="validateState('IBAN')"
                  aria-describedby="IBAN-feedback"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.IBAN.$errors"
                  id="IBAN-feedback"
                ></error-handle>
                <div v-if="erreurlist.IBAN" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.IBAN)">
                    <span
                      v-for="(e, index) in erreurlist.IBAN"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.IBAN }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <b-form-group
                :label="$t('forme_juridique')"
                label-for="forme_juridique"
              >
                <b-form-input
                  v-model="v$.newclient.forme_juridique.$model"
                  :state="validateState('forme_juridique')"
                  aria-describedby="forme_juridique-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.forme_juridique.$errors"
                  id="forme_juridique-feedback"
                ></error-handle>
                <div
                  v-if="erreurlist.forme_juridique"
                  class="error-message"
                >
                  <ul v-if="Array.isArray(erreurlist.forme_juridique)">
                    <span
                      v-for="(e, index) in erreurlist.forme_juridique"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.forme_juridique }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <b-form-group :label="$t('ape')" label-for="ape">
                <b-form-input
                  v-model="v$.newclient.ape.$model"
                  :state="validateState('ape')"
                  aria-describedby="ape-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.ape.$errors"
                  id="ape-feedback"
                ></error-handle>
                <div v-if="erreurlist.ape" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.ape)">
                    <span
                      v-for="(e, index) in erreurlist.ape"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.ape }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <b-form-group :label="$t('naf')" label-for="naf">
                <b-form-input
                  v-model="v$.newclient.naf.$model"
                  :state="validateState('naf')"
                  aria-describedby="naf-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.naf.$errors"
                  id="naf-feedback"
                ></error-handle>
                <div v-if="erreurlist.naf" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.naf)">
                    <span
                      v-for="(e, index) in erreurlist.naf"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.naf }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12 py-0">
              <b-form-group label="SWIFT_BIC" label-for="SWIFT_BIC">
                <b-form-input
                  v-model="v$.newclient.SWIFT_BIC.$model"
                  :state="validateState('SWIFT_BIC')"
                  aria-describedby="SWIFT_BIC-feedback"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.SWIFT_BIC.$errors"
                  id="SWIFT_BIC-feedback"
                ></error-handle>
                <div v-if="erreurlist.SWIFT_BIC" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.SWIFT_BIC)">
                    <span
                      v-for="(e, index) in erreurlist.SWIFT_BIC"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.SWIFT_BIC }}</span>
                </div>
              </b-form-group>
            </div>
          </div>

          <hr />

          <b-form-group
            :label="$t('COMMENTAIRE')"
            label-for="commentaire"
          >
            <b-form-textarea
              v-model="newclient.commentaire"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <div v-if="erreurlist.commentaire" class="error-message">
              <ul v-if="Array.isArray(erreurlist.commentaire)">
                <span
                  v-for="(e, index) in erreurlist.commentaire"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.commentaire }}</span>
            </div>
          </b-form-group>
        </div>

        <div v-if="!isProfessionel" style="width: 100%">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Civilite') + ' 1*'">
                <b-form-select
                  v-model="v$.newclient.civilite_1.$model"
                  :options="optionsCivilite"
                  :state="validateState('civilite_1')"
                  aria-describedby="civilite_1-feedback"
                ></b-form-select>
                <error-handle
                  :list="v$.newclient.civilite_1.$errors"
                  id="civilite_1-feedback"
                ></error-handle>
                <div v-if="erreurlist.civilite_1" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.civilite_1)">
                    <span
                      v-for="(e, index) in erreurlist.civilite_1"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.civilite_1 }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('NAME') + '*'">
                <b-form-input
                  v-model="v$.newclient.nom.$model"
                  oninput="this.value = this.value.toUpperCase()"
                  :state="validateState('nom')"
                  aria-describedby="nom-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.nom.$errors"
                  id="nom-feedback"
                ></error-handle>
                <div v-if="erreurlist.nom" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.nom)">
                    <span v-for="(e, index) in erreurlist.nom" :key="index">
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.nom }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('SURNAME') + '*'" label-for="lastname">
            <b-form-input
              v-model="v$.newclient.prenom.$model"
              oninput="this.value = this.value.toUpperCase()"
              :state="validateState('prenom')"
              aria-describedby="prenom-feedback"
            ></b-form-input>
            <error-handle
              :list="v$.newclient.prenom.$errors"
              id="prenom-feedback"
            ></error-handle>
            <div v-if="erreurlist.prenom" class="error-message">
              <ul v-if="Array.isArray(erreurlist.prenom)">
                <span v-for="(e, index) in erreurlist.prenom" :key="index">
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.prenom }}</span>
            </div>
            </b-form-group>
          </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Téléphone portable') + '**'" label-for="telephone">
                <template>
                  <phone :tel="newclient.tel_mobile" @phoneNumber="formatNumber($event)"></phone>
                </template>
                <error-handle
                  :list="v$.newclient.tel_mobile.phone_number.$errors"
                  id="tel_mobile-feedback"
                ></error-handle>
                <div v-if="erreurlist.tel_mobile" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.tel_mobile)">
                    <span
                      v-for="(e, index) in erreurlist.tel_mobile"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.tel_mobile }}</span>
                </div>
                <div
                  v-if="
                    newclient.tel_mobile && newclient.tel_mobile.phone_number && resultValid == false
                  "
                  class="error-message"
                >
                  {{ $t("ERROR_PHONE") }}
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Téléphone fixe') + '**'" label-for="telephone-fixe">
                <template>
                  <phone :tel="newclient.tel_fixe" @phoneNumber="formatNumberFixe($event)"></phone>
                </template>
                <error-handle
                  :list="v$.newclient.tel_fixe.phone_number.$errors"
                  id="tel_fixe-feedback"
                ></error-handle>
                <div v-if="erreurlist.tel_fixe" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.tel_fixe)">
                    <span
                      v-for="(e, index) in erreurlist.tel_fixe"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.tel_fixe }}</span>
                </div>
                <div
                  v-if="
                    newclient.tel_fixe && newclient.tel_fixe.phone_number && resultValidFixe == false
                  "
                  class="error-message"
                >
                  {{ $t("ERROR_PHONE") }}
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Fonction')">
                <b-form-input
                  v-model="newclient.fonction"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <div v-if="erreurlist.fonction" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.fonction)">
                    <span
                      v-for="(e, index) in erreurlist.fonction"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.fonction }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Civilite') + ' 2'">
                <b-form-select
                  v-model="newclient.civilite_2"
                  :options="optionsCivilite"
                ></b-form-select>
                <div v-if="erreurlist.civilite_2" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.civilite_2)">
                    <span
                      v-for="(e, index) in erreurlist.civilite_2"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.civilite_2 }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('NAME') + ' 2'">
                <b-form-input
                  v-model="newclient.nom_2"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <div v-if="erreurlist.nom_2" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.nom_2)">
                    <span
                      v-for="(e, index) in erreurlist.nom_2"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.nom_2 }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('SURNAME') + ' 2'">
                <b-form-input
                  v-model="newclient.prenom_2"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <div v-if="erreurlist.prenom_2" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.prenom_2)">
                    <span
                      v-for="(e, index) in erreurlist.prenom_2"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.prenom_2 }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('EMAIL') + '*'" label-for="email">
            <b-form-input
              v-model="v$.newclient.email.$model"
              :state="validateState('email')"
              aria-describedby="email-feedback"
              type="email"
            ></b-form-input>
            <error-handle
              :list="v$.newclient.email.$errors"
              id="email-feedback"
            ></error-handle>
            <div v-if="erreurlist.email" class="error-message">
              <ul v-if="Array.isArray(erreurlist.email)">
                <span v-for="(e, index) in erreurlist.email" :key="index">
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.email }}</span>
            </div>
          </b-form-group>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('EMAIL') + ' 2'" label-for="email2">
                <b-form-input
                  v-model="newclient.email_2"
                  type="email"
                ></b-form-input>
                <div v-if="erreurlist.email_2" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.email_2)">
                    <span
                      v-for="(e, index) in erreurlist.email_2"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.email_2 }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('STREET') + '*'" label-for="rue">
                <b-form-input
                  v-model="v$.newclient.rue.$model"
                  :state="validateState('rue')"
                  aria-describedby="rue-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.rue.$errors"
                  id="rue-feedback"
                ></error-handle>
                <div v-if="erreurlist.rue" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.rue)">
                    <span v-for="(e, index) in erreurlist.rue" :key="index">
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.rue }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t(' Complément d\'adresse')" label-for="complement-adresse">
                <b-form-input
                  v-model="newclient.complement_adresse"
                ></b-form-input>
                <div v-if="erreurlist.complement_adresse" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.complement_adresse)">
                    <span
                      v-for="(e, index) in erreurlist.complement_adresse"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.complement_adresse }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group
                :label="$t('POSTAL_CODE') + '*'"
                label-for="cp"
              >
                <b-form-input
                  v-model="v$.newclient.cp.$model"
                  :state="validateState('cp')"
                  aria-describedby="cp-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.cp.$errors"
                  id="cp-feedback"
                ></error-handle>
                <div v-if="erreurlist.cp" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.cp)">
                    <span
                      v-for="(e, index) in erreurlist.cp"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.cp }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('CITY') + '*'" label-for="ville">
                <b-form-input
                  v-model="v$.newclient.ville.$model"
                  :state="validateState('ville')"
                  aria-describedby="ville-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.newclient.ville.$errors"
                  id="ville-feedback"
                ></error-handle>
                <div v-if="erreurlist.ville" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.ville)">
                    <span
                      v-for="(e, index) in erreurlist.ville"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.ville }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('COUNTRY') + ''">
                <multiselect
                  v-model="newclient.pays"
                  :searchable="true"
                  :close-on-select="true"
                  :multiple="false"
                  :options="getAllcountries"
                  label="name"
                  track-by="id"
                >
                  <template slot="noResult">
                    {{ $t("NO_DATA_FOUND") }}
                  </template>
                </multiselect>
                <div v-if="erreurlist.pays" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.pays)">
                    <span
                      v-for="(e, index) in erreurlist.pays"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.pays }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('ZONE') + '*'">
                <b-form-select
                  v-model="v$.newclient.zone.$model"
                  :options="optionsZone"
                  text-field="text"
                  value-field="value"
                  :state="validateState('zone')"
                  aria-describedby="zone-feedback"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- {{ $t("ZONE") }} --</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <error-handle
                  :list="v$.newclient.zone.$errors"
                  id="zone-feedback"
                ></error-handle>
                <div v-if="erreurlist.zone" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.zone)">
                    <span
                      v-for="(e, index) in erreurlist.zone"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.zone }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('PRECARITE')">
                <b-form-select
                  v-model="newclient.precarite"
                  :options="optionsprecarite"
                  text-field="text"
                  value-field="value"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- {{ $t("PRECARITE") }} --</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <div v-if="erreurlist.precarite" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.precarite)">
                    <span
                      v-for="(e, index) in erreurlist.precarite"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.precarite }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Role') + '*'">
                <b-form-select
                  v-model="v$.newclient.type_occupation.$model"
                  :options="optionsTypeOccupation"
                  text-field="text"
                  value-field="value"
                  :state="validateState('type_occupation')"
                  aria-describedby="type_occupation-feedback"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- {{ $t("Role") }} --</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <error-handle
                  :list="v$.newclient.type_occupation.$errors"
                  id="type_occupation-feedback"
                ></error-handle>
                <div v-if="erreurlist.type_occupation" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.type_occupation)">
                    <span
                      v-for="(e, index) in erreurlist.type_occupation"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.type_occupation }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div v-if="!isProfessionel">
            <h5>{{ $t("Menage") }}</h5>
            
            <div class="row ">
              <div class="col-lg-12 col-md-12 col-sm-12 pl-2 py-0">
                <b-form-group :label="$t('Foyer fiscaux')">
                  <b-form-input
                    v-model="newclient.foyer_fiscal"
                  ></b-form-input>
                  <div v-if="erreurlist.foyer_fiscal" class="error-message">
                    <ul v-if="Array.isArray(erreurlist.foyer_fiscal)">
                      <span
                        v-for="(e, index) in erreurlist.foyer_fiscal"
                        :key="index"
                      >
                        {{ e }}
                      </span>
                    </ul>
                    <span v-else>{{ erreurlist.foyer_fiscal }}</span>
                  </div>
                </b-form-group>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 py-0">
                <b-form-group :label="$t('Année des revenus')">
                  <b-form-input
                    v-model="newclient.annee_revenus"
                    type="number"
                    min="1900"
                    max="2100"
                  ></b-form-input>
                  <div v-if="erreurlist.annee_revenus" class="error-message">
                    <ul v-if="Array.isArray(erreurlist.annee_revenus)">
                      <span
                        v-for="(e, index) in erreurlist.annee_revenus"
                        :key="index"
                      >
                        {{ e }}
                      </span>
                    </ul>
                    <span v-else>{{ erreurlist.annee_revenus }}</span>
                  </div>
                </b-form-group>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 pl-2 py-0">
                <b-form-group :label="$t('Année imposition')">
                  <b-form-input
                    v-model="newclient.annee_imposition"
                    type="number"
                    min="1900"
                    max="2100"
                  ></b-form-input>
                  <div v-if="erreurlist.annee_imposition" class="error-message">
                    <ul v-if="Array.isArray(erreurlist.annee_imposition)">
                      <span
                        v-for="(e, index) in erreurlist.annee_imposition"
                        :key="index"
                      >
                        {{ e }}
                      </span>
                    </ul>
                    <span v-else>{{ erreurlist.annee_imposition }}</span>
                  </div>
                </b-form-group>
              </div>
            </div>

            <MenagesStep
              :menageParentData="menageData"
              @update-menage="handleMenageUpdate"
            />
          </div>
        </div>

        <b-form-group :label="$t('COMPANY_ID')" v-if="isSuperAdmin">
          <multiselect
            v-model="newclient.entreprise"
            :searchable="true"
            :close-on-select="true"
            :multiple="false"
            :options="getAllentreprises"
            label="lib"
            track-by="id"
          >
            <template slot="noResult">
              {{ $t("NO_DATA_FOUND") }}
            </template>
          </multiselect>
          <div v-if="v$.newclient.entreprise.$error" class="error-message">
            {{ $t("REQUIRED_FIELD") }}
          </div>
          <div v-if="erreurlist.entreprise" class="error-message">
            <ul v-if="Array.isArray(erreurlist.entreprise)">
              <span v-for="(e, index) in erreurlist.entreprise" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.entreprise }}</span>
          </div>
        </b-form-group>
      </div>
    </form>

    <template #modal-footer>
      <b-alert variant="warning" show v-if="errorS" class="messageError">
        {{ errorS }}
      </b-alert>
      <div class="double">
        <b-button variant="danger" @click="resetModal()">
          <div class="block-spinner">
            {{ $t("CANCEL") }}
          </div>
        </b-button>
        <b-button variant="success" @click="addCLI">
          <div class="block-spinner">
            {{ $t("SAVE") }}
            <div v-if="getclientLoading" class="loading ml-2">
              <div class="spinner-border" role="status"></div>
            </div>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
 
</template>

<script>
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { domains } from "@/environment";
import { mapActions, mapGetters } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import {
  required,
  email,
  maxLength,
  minLength,
  requiredIf,
  numeric,
  helpers,
} from "@vuelidate/validators";
import errorHandle from "../ui/errorHandle.vue";
import phone from "../ui/phone.vue";
import MenagesStep from "../menages/MenagesStep.vue";

export default {
  components: {
    errorHandle,
    phone,
    MenagesStep,
    
  },
  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },

  data() {
    return {
      menageData: {},
      newclient: {
        type: "type.particulier",
        // Type particulier
        civilite_1: null,
        nom: null,
        prenom: null,
        tel_mobile: {
          phone_number: null,
          phone_iso_code: null,
        },
        tel_fixe: {
          phone_number: null,
          phone_iso_code: null,
        },
        civilite_2: null,
        nom_2: null,
        prenom_2: null,
        email: null,
        email_2: null,
        rue: null,
        complement_adresse: null,
        cp: null,
        ville: null,
        pays: null,
        // Type professionnel
        raison_sociale: null,
        nom_commercial: null,
        siret: null,
        civilite: null,
        signataire_nom: null,
        signataire_prenom: null,
        fonction: null,
        tel_mobile_pro: {
          phone_number: null,
          phone_iso_code: null,
        },
        tel_fixe_pro: {
          phone_number: null,
          phone_iso_code: null,
        },
        ape_naf: null,
        // Common fields
        entreprise: null,
        company_tel: {
          phone_number: null,
          phone_iso_code: null,
        },
        zone: null,
        precarite: null,
        type_occupation: null,
        // Foyer fiscal
        foyer_fiscal: null,
        annee_revenus: null,
        annee_imposition: null,
        SWIFT_BIC: null,
        forme_juridique: null,
        ape: null,
        naf: null,
        IBAN: null,
        titulaire_compte: null,
        poste: null,
        commentaire: null,
        company: null,
        company_email: null,
      },
      erreurlist: {
        nom: null,
        prenom: null,
        email: null,
        rue: null,
        cp: null,
        ville: null,
        tel_mobile: null,
        tel_fixe: null,
        type: null,
        entreprise: null,
        pays: null,
        civilite_1: null,
        civilite_2: null,
        nom_2: null,
        prenom_2: null,
        email_2: null,
        raison_sociale: null,
        nom_commercial: null,
        siret: null,
        civilite: null,
        signataire_nom: null,
        signataire_prenom: null,
        fonction: null,
        tel_mobile_pro: null,
        tel_fixe_pro: null,
        ape_naf: null,
        zone: null,
        precarite: null,
        type_occupation: null,
        complement_adresse: null,
        SWIFT_BIC: null,
        forme_juridique: null,
        ape: null,
        naf: null,
        IBAN: null,
        titulaire_compte: null,
        commentaire: null,
        company: null,
        company_email: null,
        company_tel: null,
        // Foyer fiscal
        foyer_fiscal: null,
        annee_revenus: null,
        annee_imposition: null,
      },
      galleryUrl: domains.gallery,
      optionsTypeClient: [
        { value: "type.particulier", text: this.$t("PARTICULAR") },
        { value: "type.professionnel", text: this.$t("PROFESSIONAL") },
        { value: "type.bailleur_sociale", text: "Bailleur sociale" },
        { value: "type.syndic_copropriete_professionnel", text: "Syndic copropriété professionnel" },
        { value: "type.entreprise", text: "Entreprise" },
        { value: "type.etablissement", text: "Établissement" },
        { value: "type.collectivite_territoriale_mairie", text: "Collectivité territoriale / Mairie" },
        { value: "type.organisation_professionnelle", text: "Organisation professionnelle" },
        { value: "type.syndic_copropriete_benevole", text: "Syndic copropriété bénévole" },
      ],
      optionsCivilite: [
        { value: "Monsieur", text: "Monsieur" },
        { value: "Madame", text: "Madame" },
      ],
      optionsZone: [
        { value: "h1", text: "H1" },
        { value: "h2", text: "H2" },
        { value: "h3", text: "H3" },
      ],
      optionsprecarite: [
        { value: "Modeste", text: this.$t("Modeste") },
        { value: "Intermédiaires", text: this.$t("Intermédiaires") },
        { value: "tres_modeste", text: this.$t("Tmodeste") },
        { value: "supérieurs", text: this.$t("Supérieurs") },
      ],
      optionsTypeOccupation: [
        { value: "Propriétaire", text: "Propriétaire" },
        { value: "locataire", text: "Locataire" },
        { value: "autre", text: "Autre" },
        { value: "Maître d'ouvrage", text: "Maître d'ouvrage" },
      ],
      optionstypechauffage: [
        { value: "combustible_bois", text: this.$t("Combustible/Bois") },
        { value: "electrique", text: this.$t("Electrique") },
        { value: "gaz", text: this.$t("Gaz") },
        { value: "fuel", text: this.$t("Fuel") },
        { value: "bois", text: this.$t("Bois") },
        { value: "pac", text: "PAC" },
      ],
      optionstypelogement: [
        { value: "maison_individuelle", text: this.$t("Maison individuelle") },
        { value: "appartement", text: this.$t("Appartement") },
      ],
      errorS: null,
      box: "",
      isLoading: false,
      resultValid: null,
      resultValidFixe: null,
      phoneValid: null,
      resultValidMobilePro: null,
      resultValidFixePro: null,
      vueTel: {
        preferredCountries: ["FR", "TN"],
        placeholder: "Enter your phone",
        mode: "auto",
        inputOptions: {
          showDialCode: true,
        },
        disabledFormatting: false,
        validCharactersOnly: true,
        wrapperClasses: "country-phone-input",
      },
    };
  },
  validations() {
    return {
      newclient: {
        type: { required },
        // Champs obligatoires pour tous les types
        nom: {
          required,
          maxLength: maxLength(100),
        },
        prenom: {
          required,
          maxLength: maxLength(100),
        },
        email: {
          required,
          email,
          maxLength: maxLength(50),
        },
        rue: {
          required,
          maxLength: maxLength(100),
        },
        cp: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(5),
        },
        ville: {
          required,
          maxLength: maxLength(100),
        },
        zone: {
          required,
        },
        type_occupation: {
          required,
        },
        // Téléphones particulier : rendre optionnels (gérés côté métier, pas bloquant pour la création)
        tel_mobile: {
          phone_number: {},
        },
        tel_fixe: {
          phone_number: {},
        },
        // Champs optionnels
        civilite_1: {},
        pays: {},
        entreprise: { requiredIf: requiredIf(this.isSuperAdmin) },
        // Champs obligatoires pour professionnel
        raison_sociale: {
          requiredIf: requiredIf(() => this.isProfessionel),
          maxLength: maxLength(100),
        },
        siret: {
          requiredIf: requiredIf(() => this.isProfessionel),
        },
        signataire_nom: {
          maxLength: maxLength(100),
        },
        signataire_prenom: {
          maxLength: maxLength(100),
        },
        company: {
          maxLength: maxLength(100),
        },
        company_email: {
          email,
          maxLength: maxLength(50),
        },
        tel_mobile_pro: {
          phone_number: {
            requiredIf: requiredIf(() => {
              // Seulement pour les professionnels
              if (!this.isProfessionel) return false;
              // Vérifier si tel_fixe_pro n'est pas rempli
              const hasTelFixePro = this.newclient.tel_fixe_pro && this.newclient.tel_fixe_pro.phone_number;
              return !hasTelFixePro;
            }),
          },
        },
        tel_fixe_pro: {
          phone_number: {
            requiredIf: requiredIf(() => {
              // Seulement pour les professionnels
              if (!this.isProfessionel) return false;
              // Vérifier si tel_mobile_pro n'est pas rempli
              const hasTelMobilePro = this.newclient.tel_mobile_pro && this.newclient.tel_mobile_pro.phone_number;
              return !hasTelMobilePro;
            }),
          },
        },
        poste: {
          maxLength: maxLength(40),
        },
        forme_juridique: {},
        naf: {},
        ape: {},
        SWIFT_BIC: {
          swiftBicFormat: helpers.withMessage(
            () => this.$t("SWIFT_BIC_FORMAT_ERROR") || "Le code SWIFT/BIC doit contenir exactement 8 ou 11 caractères alphanumériques",
            (value) => {
              if (!value || value.trim() === '') return true; // Optional field
              const cleanValue = value.trim().toUpperCase();
              // Must be exactly 8 or 11 characters and alphanumeric
              return (cleanValue.length === 8 || cleanValue.length === 11) && /^[A-Z0-9]+$/.test(cleanValue);
            }
          ),
        },
        IBAN: {
          ibanFormat: helpers.withMessage(
            () => this.$t("IBAN_FORMAT_ERROR") || "L'IBAN doit être alphanumérique (les espaces sont autorisés)",
            (value) => {
              if (!value || value.trim() === '') return true; // Optional field
              const cleanValue = value.replace(/\s+/g, ''); // Remove all spaces
              // Must be alphanumeric and max 34 characters without spaces
              return /^[A-Z0-9]+$/i.test(cleanValue) && cleanValue.length <= 34;
            }
          ),
        },
        titulaire_compte: { maxLength: maxLength(40) },
        // Additional fields used in template but not always validated
        tel: {},
        revenu_avis_imposition: {},
        complement_adresse: {},
        civilite_2: {},
        nom_2: {},
        prenom_2: {},
        email_2: {},
        nom_commercial: {},
        civilite: {},
        fonction: {},
        commentaire: {},
        precarite: {},
        foyer_fiscal: {},
        annee_revenus: {},
        annee_imposition: {},
      },
    };
  },
  methods: {
    ...mapActions(["store_clients", "all_countries", "storeMenage", "all_entreprises"]),
    handleMenageUpdate({ field, value }) {
      if (!this.menageData) {
        this.menageData = {};
      }
      this.menageData[field] = value;
    },

    validateState(name) {
      if (!this.v$.newclient[name]) {
        return null;
      }
      const { $dirty, $error } = this.v$.newclient[name];
      return $dirty ? !$error : null;
    },
    updateSignataireNom(event) {
      const value = event.target ? event.target.value : event;
      this.newclient.signataire_nom = value;
    },
    updateSignatairePrenom(event) {
      const value = event.target ? event.target.value : event;
      this.newclient.signataire_prenom = value;
    },
    hasValidationError(fieldPath) {
      try {
        const path = fieldPath.split('.');
        let obj = this.v$;
        for (const key of path) {
          if (!obj || !obj[key]) return false;
          obj = obj[key];
        }
        return obj.$error || false;
      } catch (e) {
        return false;
      }
    },

    formatNumber(event) {
      this.newclient.tel_mobile = {
        phone_number: event.number,
        phone_iso_code: event.country.iso2,
      };
      this.resultValid = event.isValid;
    },

    formatNumberFixe(event) {
      this.newclient.tel_fixe = {
        phone_number: event.number,
        phone_iso_code: event.country.iso2,
      };
      this.resultValidFixe = event.isValid;
    },

    formatNumberE(event) {
      this.newclient.company_tel = {
        phone_number: event.number,
        phone_iso_code: event.country.iso2,
      };
      this.phoneValid = event.isValid;
    },

    formatMobileNumberPro(event) {
      this.newclient.tel_mobile_pro = {
        phone_number: event.number,
        phone_iso_code: event.country.iso2,
      };
      this.resultValidMobilePro = event.isValid;
    },

    formatFixedNumberPro(event) {
      this.newclient.tel_fixe_pro = {
        phone_number: event.number,
        phone_iso_code: event.country.iso2,
      };
      this.resultValidFixePro = event.isValid;
    },

    async addCLI() {
      console.log("[clientStoreModal] addCLI() called", {
        type: this.newclient?.type,
        isProfessionel: this.isProfessionel,
      });
      // Valider le formulaire avant de soumettre
      const isFormValid = await this.v$.$validate();
      console.log("[clientStoreModal] validation result", { isFormValid });
      if (!isFormValid) {
        console.log("[clientStoreModal] validation failed", {
          errors: this.v$?.$errors,
        });
        this.isLoading = false;
        return;
      }

      this.isLoading = true;
      
      this.erreurlist = {
        nom: null,
        prenom: null,
        email: null,
        rue: null,
        cp: null,
        ville: null,
        tel: null,
        type: null,
        entreprise: null,
        pays: null,
        SWIFT_BIC: null,
        forme_juridique: null,
        ape: null,
        naf: null,
        IBAN: null,
        titulaire_compte: null,
        commentaire: null,
        company: null,
        company_email: null,
        company_tel: null,
        zone: null,
        precarite: null,
        type_occupation: null,
        tel_mobile: null,
        tel_fixe: null,
        civilite_1: null,
        civilite_2: null,
        nom_2: null,
        prenom_2: null,
        email_2: null,
        raison_sociale: null,
        nom_commercial: null,
        siret: null,
        civilite: null,
        signataire_nom: null,
        signataire_prenom: null,
        fonction: null,
        tel_mobile_pro: null,
        tel_fixe_pro: null,
        complement_adresse: null,
        foyer_fiscal: null,
        annee_revenus: null,
        annee_imposition: null,
      };
      this.errorS = null;

      const data = {
        type: this.newclient.type,
        nom: this.newclient.nom,
        prenom: this.newclient.prenom,
        email: this.isProfessionel ? null : this.newclient.email, // Email sera défini plus tard pour professionnel
        rue: this.newclient.rue,
        complement_adresse: this.newclient.complement_adresse || null,
        cp: this.newclient.cp,
        ville: this.newclient.ville,
        pays: this.newclient.pays ? this.newclient.pays.iso_code : null,
      };
      console.log("[clientStoreModal] base payload", { data });

      // Champs pour particulier
      if (!this.isProfessionel) {
        if (this.newclient.civilite_1) {
          data.civilite_1 = this.newclient.civilite_1;
        }
        if (this.newclient.civilite_2) {
          data.civilite_2 = this.newclient.civilite_2;
        }
        if (this.newclient.nom_2) {
          data.nom_2 = this.newclient.nom_2;
        }
        if (this.newclient.prenom_2) {
          data.prenom_2 = this.newclient.prenom_2;
        }
        if (this.newclient.email_2) {
          data.email_2 = this.newclient.email_2;
        }
      }

      // Champs pour professionnel
      if (this.isProfessionel) {
        if (this.newclient.raison_sociale) {
          data.raison_sociale = this.newclient.raison_sociale;
        }
        if (this.newclient.nom_commercial) {
          data.nom_commercial = this.newclient.nom_commercial;
        }
        if (this.newclient.siret) {
          data.siret = this.newclient.siret;
        }
        if (this.newclient.civilite) {
          data.civilite = this.newclient.civilite;
        }
        // Utiliser nom et prenom pour définir signataire_nom et signataire_prenom
        if (this.newclient.nom) {
          data.nom = this.newclient.nom;
          data.signataire_nom = this.newclient.nom;
        }
        if (this.newclient.prenom) {
          data.prenom = this.newclient.prenom;
          data.signataire_prenom = this.newclient.prenom;
        }
        if (this.newclient.ape_naf) {
          data.ape_naf = this.newclient.ape_naf;
        }
        
        // Company is the same as nom and prenom (always required for professionnel)
        if (this.newclient.nom && this.newclient.prenom) {
          data.company = `${this.newclient.nom} ${this.newclient.prenom}`.trim();
        } else if (this.newclient.nom) {
          data.company = this.newclient.nom;
        } else if (this.newclient.prenom) {
          data.company = this.newclient.prenom;
        } else {
          // Fallback: use raison_sociale or nom_commercial if available
          data.company = this.newclient.raison_sociale || this.newclient.nom_commercial || "";
        }
      }

      // Format numero tel
      // Format numero tel mobile pour particulier
      if (!this.isProfessionel && this.newclient.tel_mobile && this.newclient.tel_mobile.phone_number) {
        var num = this.newclient.tel_mobile.phone_number.indexOf(" ");
        if (num !== -1) {
          data.phone_number = this.newclient.tel_mobile.phone_number
            .slice(num + 1)
            .split(" ")
            .join("");
        } else {
          data.phone_number = this.newclient.tel_mobile.phone_number
            .split(" ")
            .join("");
        }
        data.tel = data.phone_number;
        data.phone_iso_code = this.newclient.tel_mobile.phone_iso_code;
      }
      
      // Format numero tel fixe pour particulier
      if (!this.isProfessionel && this.newclient.tel_fixe && this.newclient.tel_fixe.phone_number) {
        var numFixe = this.newclient.tel_fixe.phone_number.indexOf(" ");
        if (numFixe !== -1) {
          data.tel_fixe = this.newclient.tel_fixe.phone_number
            .slice(numFixe + 1)
            .split(" ")
            .join("");
        } else {
          data.tel_fixe = this.newclient.tel_fixe.phone_number
            .split(" ")
            .join("");
        }
        data.tel_fixe_phone_number = data.tel_fixe;
        data.tel_fixe_phone_iso_code = this.newclient.tel_fixe.phone_iso_code;
      }

      // Format numero tel mobile pour professionnel (tel = tel_mobile_pro)
      if (this.isProfessionel && this.newclient.tel_mobile_pro && this.newclient.tel_mobile_pro.phone_number) {
        var numPro = this.newclient.tel_mobile_pro.phone_number.indexOf(" ");
        if (numPro !== -1) {
          data.phone_number = this.newclient.tel_mobile_pro.phone_number
            .slice(numPro + 1)
            .split(" ")
            .join("");
        } else {
          data.phone_number = this.newclient.tel_mobile_pro.phone_number
            .split(" ")
            .join("");
        }
        data.tel = data.phone_number;
        data.phone_iso_code = this.newclient.tel_mobile_pro.phone_iso_code;
      }

      // Format numero tel company pour professionnel (company_tel = tel_fixe_pro)
      if (this.isProfessionel && this.newclient.tel_fixe_pro && this.newclient.tel_fixe_pro.phone_number) {
        var numFixePro = this.newclient.tel_fixe_pro.phone_number.indexOf(" ");
        if (numFixePro !== -1) {
          data.company_tel = this.newclient.tel_fixe_pro.phone_number
            .slice(numFixePro + 1)
            .split(" ")
            .join("");
        } else {
          data.company_tel = this.newclient.tel_fixe_pro.phone_number
            .split(" ")
            .join("");
        }

        data.company_phone_number = data.company_tel;
        data.company_phone_iso_code = this.newclient.tel_fixe_pro.phone_iso_code;
      }

      if (this.isCommercialBatigo) {
        data.entreprise_id = this.$route.query.entreprise;
      }
      if (this.isSuperAdmin) {
        if (this.newclient.entreprise)
          data.entreprise_id = this.newclient.entreprise.id;
        else data.entreprise_id = this.getOnlineUser.entreprise.id;
      }
      if (this.newclient.zone) {
        data.zone = this.newclient.zone;
      }
      if (this.newclient.precarite) {
        data.precarite = this.newclient.precarite;
      }
      if (this.newclient.type_occupation) {
        data.type_occupation = this.newclient.type_occupation;
      }
      if (this.newclient.titulaire_compte) {
        data.titulaire_compte = this.newclient.titulaire_compte;
      }
      if (this.newclient.poste) {
        data.poste = this.newclient.poste;
      }
      if (this.newclient.commentaire) {
        data.commentaire = this.newclient.commentaire;
      }
      if (this.newclient.SWIFT_BIC) {
        // Remove spaces and convert to uppercase before sending to backend
        data.SWIFT_BIC = this.newclient.SWIFT_BIC.replace(/\s+/g, '').toUpperCase();
      }

      if (this.newclient.forme_juridique) {
        data.forme_juridique = this.newclient.forme_juridique;
      }
      if (this.newclient.ape) {
        data.ape = this.newclient.ape;
      }
      if (this.newclient.naf) {
        data.naf = this.newclient.naf;
      }

      if (this.newclient.IBAN) {
        // Remove spaces from IBAN before sending to backend
        data.IBAN = this.newclient.IBAN.replace(/\s+/g, '').toUpperCase();
      }
      // Company email for professionnel (from email)
      // Company email doit être le même que email pour professionnel à la création
      if (this.isProfessionel) {
        if (this.newclient.email) {
          data.company_email = this.newclient.email;
          data.email = this.newclient.email; // Email est le même que email
        } else if (this.newclient.company_email) {
          data.company_email = this.newclient.company_email;
          data.email = this.newclient.company_email; // Email est le même que company_email
        }
      } else if (this.newclient.company_email) {
        data.company_email = this.newclient.company_email;
      }

      console.log("[clientStoreModal] final payload before API", { data });
      
      // Poste (from fonction) for professionnel and particulier
      if (this.newclient.fonction) {
        data.poste = this.newclient.fonction;
      } else if (this.newclient.poste) {
        data.poste = this.newclient.poste;
      }
      try {
        console.log("[clientStoreModal] calling store_clients...");
        const clientResult = await this.store_clients(data);
        console.log("[clientStoreModal] store_clients result", { clientResult });
        if (
          clientResult.status_code === 422 ||
          clientResult.status_code === 409
        ) {
          // Erreur de validation (email déjà utilisé ou autre 422/409)
          const message = clientResult.message || "e-mail existe déjà";
          console.log("[clientStoreModal] store_clients validation error", {
            status_code: clientResult.status_code,
            message,
          });
          if (this.isObject(message)) {
            // Message structuré par champ → remplir erreurlist
            Object.entries(message).forEach(([key, value]) => {
              if (!this.erreurlist[key]) {
                this.erreurlist[key] = value;
              }
            });
          } else {
            // Message simple → afficher dans l'alerte du modal
            this.errorS = message;
          }
          this.isLoading = false;
          return;
        }
        // Store menage only for particulier (if data is available)
        const hasMenageData = (this.menageData && (this.menageData.revenu || this.menageData.personnes || this.menageData.commune)) || 
                               this.newclient.foyer_fiscal || 
                               this.newclient.annee_revenus || 
                               this.newclient.annee_imposition;
        if (!this.isProfessionel && hasMenageData) {
          const menage = {
            client_id: clientResult.id,
            revenu: (this.menageData && this.menageData.revenu) || null,
            personnes: (this.menageData && this.menageData.personnes) || null,
            commune: (this.menageData && this.menageData.commune) || null,
            foyer_fiscal: this.newclient.foyer_fiscal || null,
            annee_revenus: this.newclient.annee_revenus || null,
            annee_imposition: this.newclient.annee_imposition || null,
          };
          console.log("[clientStoreModal] creating menage", { menage });
          await this.storeMenage(menage).catch(err => {
            console.warn("Erreur lors de la création du ménage:", err);
            // Continue même si le ménage n'a pas pu être créé
          });
        }

        console.log("[clientStoreModal] success -> closing modal, emitting events", {
          clientId: clientResult?.id,
        });
        this.resetModal();
        this.errorS = null;
        this.isLoading = false;
        this.$emit("affichage", clientResult);
        this.$emit("updateList");
      } catch (err) {
        console.log("[clientStoreModal] store_clients threw error", err);
        if (this.isObject(err)) {
          for (const [key, value] of Object.entries(err)) {
            if (!this.erreurlist[key]) {
              this.erreurlist[key] = value;
            }
          }
        } else {
          this.errorS = err;
        }
        this.isLoading = false;
      }
    },
    isObject(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },
    resetModal() {
      this.errorS = null;
      this.$refs["clientStoreModal"].hide();
      this.$nextTick(() => {
        this.v$.$reset();
      });
      this.erreurlist = {
        nom: null,
        prenom: null,
        email: null,
        rue: null,
        cp: null,
        ville: null,
        tel_mobile: null,
        tel_fixe: null,
        type: null,
        entreprise: null,
        pays: null,
        SWIFT_BIC: null,
        forme_juridique: null,
        ape: null,
        naf: null,
        IBAN: null,
        titulaire_compte: null,
        commentaire: null,
        company: null,
        company_email: null,
        company_tel: null,
        zone: null,
        precarite: null,
        type_occupation: null,
        civilite_1: null,
        civilite_2: null,
        nom_2: null,
        prenom_2: null,
        email_2: null,
        raison_sociale: null,
        nom_commercial: null,
        siret: null,
        civilite: null,
        signataire_nom: null,
        signataire_prenom: null,
        fonction: null,
        tel_mobile_pro: null,
        tel_fixe_pro: null,
        complement_adresse: null,
        foyer_fiscal: null,
        annee_revenus: null,
        annee_imposition: null,
      };
      this.menageData = {};
      this.newclient = {
        type: "type.particulier",
        // Type particulier
        civilite_1: null,
        nom: null,
        prenom: null,
        tel_mobile: {
          phone_number: null,
          phone_iso_code: null,
        },
        tel_fixe: {
          phone_number: null,
          phone_iso_code: null,
        },
        civilite_2: null,
        nom_2: null,
        prenom_2: null,
        email: null,
        email_2: null,
        rue: null,
        complement_adresse: null,
        cp: null,
        ville: null,
        pays: null,
        // Type professionnel
        raison_sociale: null,
        nom_commercial: null,
        siret: null,
        civilite: null,
        signataire_nom: null,
        signataire_prenom: null,
        fonction: null,
        tel_mobile_pro: {
          phone_number: null,
          phone_iso_code: null,
        },
        tel_fixe_pro: {
          phone_number: null,
          phone_iso_code: null,
        },
        ape_naf: null,
        // Common fields
        entreprise: null,
        company_tel: {
          phone_number: null,
          phone_iso_code: null,
        },
        zone: null,
        precarite: null,
        type_occupation: null,
        // Foyer fiscal
        foyer_fiscal: null,
        annee_revenus: null,
        annee_imposition: null,
        SWIFT_BIC: null,
        forme_juridique: null,
        ape: null,
        naf: null,
        IBAN: null,
        titulaire_compte: null,
        poste: null,
        commentaire: null,
        company: null,
        company_email: null,
      };
    },

    close(bv) {
      if (this.$refs["clientStoreModal"].isShow) {
        if (bv.trigger == "backdrop") {
          bv.preventDefault();
          this.showMsgBox();
        }
      }
    },

    showMsgBox() {
      this.box = "";
      this.$bvModal
        .msgBoxConfirm(`${this.$t("CLOSE")}`, {
          title: `${this.$t("CONFIRM")}`,
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          okTitle: `${this.$t("YES")}`,
          cancelTitle: `${this.$t("NO")}`,
          footerClass: "p-2",
          hideHeaderClose: false,
        })
        .then((value) => {
          if (value) {
            this.resetModal();
          }
        });
    },
  },

  mounted() {
    this.all_countries({ page: this.page, perPage: 100000 });
    if (this.isSuperAdmin) {
      this.all_entreprises({ page: 1, per_page: 1000 });
    }
  },

  computed: {
    ...mapGetters([
      "getSelectedLang",
      "getPays",
      "getclientLoading",
      "getOnlineUser",
      "getAllentreprises",
      "getdictionnaire",
      "getAllcountries",
    ]),

    isCommercialBatigo() {
      return this.getOnlineUser.role == "user.commercial-batigo";
    },
    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
    isProfessionel() {
      const professionalTypes = [
        'type.professionnel',
        'type.bailleur_sociale',
        'type.syndic_copropriete_professionnel',
        'type.entreprise',
        'type.etablissement',
        'type.collectivite_territoriale_mairie',
        'type.organisation_professionnelle',
        'type.syndic_copropriete_benevole'
      ];
      return professionalTypes.includes(this.newclient.type);
    },
  },
};
</script>

<style lang="scss" scoped>
.actionModel {
  position: relative;
  padding: 52px 0 0;

  .messageError {
    position: absolute;
    top: 5px;
    bottom: 44px;
    color: #e4261b;
    margin: 0;
    font-size: 15px;
    background-color: #fff;
    border-color: #fff;
  }
}
.titresociete {
  color: #334081;
  width: 100%;
  margin-top: 4px;
}
</style>
